<div class="legend">
  <div class="legend-header">
    <div>
      Debug Panel
    </div>
    <button mat-icon-button
            class="configure-button"
            (click)="closeBox()"
            matTooltip="Close Debug Panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="debug-info">
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Zoom Level:</div>
      <span>{{ zoomLevel | number:'0.2-2' }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Current snapshot:</div>
      <span>{{ snapshot }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>UTC time:</div>
      <span>{{ utcTime | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Unix time:</div>
      <span>{{ unixTime }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Raw Data time:</div>
      <span>{{ lineDataTime }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Tenant ID:</div>
      <span>{{ configuration?.id }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Environment:</div>
      <span>{{ environment }}</span>
    </div>
    <div class="flex-row justify-content-space-between align-items-center">
      <div>Map Center:</div>
      <span class="whitespace-no-wrap">{{ center?.lng | number:'0.4-4' }}, {{ center?.lat | number:'0.4-4' }}</span>
    </div>

    <div class="w-100">
      <button mat-button
              (click)="refreshData()"
              [disabled]="loadingData"
              class="w-100"
      >
        <div class="flex-row align-items-center">
          <span>Refresh raw data</span>
          @if (loadingData) {
            <mat-spinner [diameter]="14"></mat-spinner>
          }
        </div>
      </button>
    </div>
  </div>
</div>
